export const getYoutubeThumbnailUrl = (youtubeVideoId: string) =>
  `https://img.youtube.com/vi/${youtubeVideoId.trim()}/hqdefault.jpg`

export const getWebinarThumbnailUrl = (webinar: {
  thumbnail_url?: string | null
  youtube_video_id: string
}) => {
  const customThumbnail = webinar.thumbnail_url?.trim()
  if (customThumbnail) return customThumbnail
  if (!webinar.youtube_video_id?.trim()) return ''
  return getYoutubeThumbnailUrl(webinar.youtube_video_id)
}
